import { TffCenterTileFragment } from "@generated-types"
import { Link } from "eddev/routing"
import { ReactNode } from "react"
import { formatTffCenterStatus } from "./tff-utils"
import { Chip } from "@components/ui/Chip"
import { cn } from "@utils/tw"

type Props = {
  center: Omit<TffCenterTileFragment, "title"> & { title: string | null | ReactNode }
  className?: string
}

export function TFFCenterTile(props: Props) {
  const { center } = props

  const status = formatTffCenterStatus(props.center.centerInfo!)

  return (
    <Link
      href={center.uri}
      draggable={false}
      className={cn(
        "text-fg bg-bg-mid p-4 gap-8 flex flex-col transition-colors duration-400 is-theme-dark:hover:bg-neutral-700 justify-between",
        props.className,
      )}
    >
      <div className="flex flex-col items-start gap-2">
        <div className="type-title-l">{props.center.title}</div>
        <div className="type-label-caps">{status.datesText}</div>
      </div>
      <div>
        {!!status.saleStatusLabel && (
          <Chip shape="rounded" variant={status.onSale ? "hero" : "mid"}>
            {status.saleStatusLabel}
          </Chip>
        )}
      </div>
    </Link>
  )
}
